import { action, observe, observable, autorun } from 'mobx';
import { ghIsTransferNeeded } from '~/common/globals.js';

// include UI numbers store
import { lockNumberStore } from '~/common/stores/domain/lockNumber.js';

class TransferNumberClass {
    @observable transferNumberValue = '';
    @observable transferNumber = false;
    @observable transferNumberLength = 0;
    @observable preselectedTransferNeeded = false;

    bootstrapStore() {
        observe(lockNumberStore, 'selectedNumberType', (change) => {
            if (change.newValue !== 'Transfer') {
                this.setTransferNumberValue('');
                this.setTransferNumber(false);
                this.setTransferNumberLength(0);
            }
        });

        autorun((reaction) => {
            if (ghIsTransferNeeded() === 'true') {
                this.setPreselectedTransferNeeded(true);
                reaction.dispose();
            }
        });
    }

    @action setPreselectedTransferNeeded(bool) {
        if (typeof bool === 'boolean') {
            this.preselectedTransferNeeded = bool;
        }
    }

    @action setTransferNumberValue(number) {
        if (typeof number === 'string') {
            this.transferNumberValue = number;
            this.setTransferNumberLength(number);
        }
    }

    @action setTransferNumberLength(num) {
        if (num === 0) {
            this.transferNumberLength = 0;
        } else {
            this.transferNumberLength = num.replace(/\D/g, '').length;
        }
    }

    @action setTransferNumber(bool) {
        if (typeof bool === 'boolean') {
            this.transferNumber = bool;
        }
    }
}

const transferNumberStore = new TransferNumberClass();
export { transferNumberStore, TransferNumberClass };
